import React from 'react';

import Box from '@mui/material/Box';

const ListItemSelectionMark = () => {
  return (
    <Box width={3} position="absolute" height="100%" bgcolor="black" left={0} />
  );
};

export default ListItemSelectionMark;
